<!-- 
  @desc 重置用户密码
-->
<template>
  <el-container class="main_panel" direction="vertical">
    <el-col :span="24"> <title-bar :titleBar="'重置用户密码'"></title-bar></el-col>
    <el-container direction="vertical" class="content_panel">
      <el-row :gutter="16" class="search_panel">
        <el-col :span="4">
          <el-select
            v-model="UserListVO.orgType"
            placeholder="单位类型"
            size="small"
            clearable
            @change="gamePageList()"
          >
            <el-option
              v-for="(item, index) in dict.orgType"
              :key="index"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-col>
        <!-- 请输入名称 -->
        <el-col :span="4">
          <el-input v-model="UserListVO.name" placeholder="请输入单位名称" size="small" @change="gamePageList()">
            <i class="el-icon-search el-input__icon" slot="suffix" @click="gamePageList()"></i>
          </el-input>
        </el-col>
        <!-- 查询 -->
        <el-col :span="4" align="left">
          <el-button type="primary" size="small" @click="gamePageList()" icon="el-icon-search">查询</el-button>
        </el-col>
      </el-row>
      <el-table :data="tableData" class="table" height="500" stripe border size="small">
        <el-table-column label="单位名称" align="left" prop="orgName"></el-table-column>
        <el-table-column label="单位类型" align="left" width="200" prop="orgTypeName"></el-table-column>
        <el-table-column label="昵称" align="left" prop="nickName"></el-table-column>
        <el-table-column label="用户名" align="left" width="160" prop="username"></el-table-column>
        <!-- 状态 -->
        <el-table-column align="center" width="160" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 'ENABLE'" class="gl_VALID">
              {{ scope.row.statusName }}
            </span>
            <span v-else class="gl_TEMP">
              {{ scope.row.statusName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="left">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="openReset(scope.row)">重置密码</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <Page :total="total" @current-change="changePage" :pageSize="pageSize" />
    </el-container>
    <el-dialog
      title="重置密码"
      :visible.sync="dialogVisible"
      width="30rem"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-form
        ref="UserResetPasswordVO"
        :model="UserResetPasswordVO"
        :rules="$rules.resetPassword_rules"
        size="small"
        style="width:80%;margin: auto;"
      >
        <el-form-item prop="password">
          <el-input v-model.trim="UserResetPasswordVO.password" placeholder="请输入密码">
            <template slot="prepend">
              <i class="el-icon-lock"></i>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-row :gutter="30">
          <el-col :span="12" align="center">
            <el-button type="primary" @click="clickCancel()" style="width: 60%;">
              取 消
            </el-button>
          </el-col>
          <el-col :span="12" align="center">
            <el-button @click="clickReset('REJECTED')" style="width: 60%;">
              提 交
            </el-button>
          </el-col>
        </el-row>
      </span>
    </el-dialog>
  </el-container>
</template>
<script>
import { mapGetters } from "vuex";
import { UserListVO, UserResetPasswordVO } from "@/libs/model";
import Page from "@/components/public/Page.vue";
export default {
  components: {
    Page
  },
  data() {
    return {
      UserListVO: new UserListVO(),
      UserResetPasswordVO: new UserResetPasswordVO(),
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false
    };
  },
  computed: {
    // ...mapState({
    //   role: state => state.role,
    //   userInfo: state => state.userInfo
    // }),
    ...mapGetters(["dictAll", "dict"])
  },
  watch: {
    // 标签选择框是否显示
    dialogVisible(val) {
      if (!val) {
        this.$refs["UserResetPasswordVO"].resetFields();
      }
    }
  },
  created() {
    // this.getYear();
    this.gamePageList();
  },
  methods: {
    gamePageList(page) {
      this.UserListVO.page = page ? page : 1;
      let _userListVO = JSON.parse(JSON.stringify(this.UserListVO));
      this.$http.userListPage(_userListVO).then(res => {
        if (res.data.status === "SUCCESS" && res.data.data.data) {
          this.tableData = res.data.data.data;
          this.total = res.data.data.total;
          this.page = res.data.data.page;
        }
      });
    },
    /** 页码变化 */
    changePage(val) {
      // this.UserListVO.page = val;
      this.gamePageList(val);
    },
    /** 重置密码 */
    openReset(row) {
      this.UserResetPasswordVO = new UserResetPasswordVO();
      this.UserResetPasswordVO.userAuthId = row.userAuthId;
      this.UserResetPasswordVO.password = this.randomWord(true, 6, 16);
      this.dialogVisible = true;
    },
    checkUpdatePwd(fun) {
      this.$refs["UserResetPasswordVO"].validate(valid => {
        if (valid) {
          fun(valid);
        }
      });
    },
    clickReset() {
      this.checkUpdatePwd(() => {
        this.$http.passwordReset(this.UserResetPasswordVO).then(response => {
          var res = this.$http.data(response);
          if (this.$http.success(res)) {
            this.$message({
              message: "重置成功",
              type: "success"
            });
            this.UserResetPasswordVO = new UserResetPasswordVO();
            this.dialogVisible = false;
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    clickCancel() {
      this.dialogVisible = false;
    },
    randomWord(randomFlag, min, max) {
      var str = "",
        range = min,
        arr = [
          "0",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "a",
          "b",
          "c",
          "d",
          "e",
          "f",
          "g",
          "h",
          "i",
          "j",
          "k",
          "l",
          "m",
          "n",
          "o",
          "p",
          "q",
          "r",
          "s",
          "t",
          "u",
          "v",
          "w",
          "x",
          "y",
          "z",
          "A",
          "B",
          "C",
          "D",
          "E",
          "F",
          "G",
          "H",
          "I",
          "J",
          "K",
          "L",
          "M",
          "N",
          "O",
          "P",
          "Q",
          "R",
          "S",
          "T",
          "U",
          "V",
          "W",
          "X",
          "Y",
          "Z"
        ];

      // 随机产生
      if (randomFlag) {
        range = Math.round(Math.random() * (max - min)) + min;
      }
      for (var i = 0; i < range; i++) {
        let pos = Math.round(Math.random() * (arr.length - 1));
        str += arr[pos];
      }
      return str;
    }
  }
};
</script>
